// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"0d6ac8e0","560":"04d2d7c3","673":"2de3a75f","914":"95b6d7d7","941":"d2866959"}[chunkId] + ".chunk.js";
};